import React from 'react';
import useBreakpoints from '../hooks/useBreakPoint';
import ArrowRight from './icons/ArrowRight';
import './NextArrow.css';

const NextArrow = ({ onClick, className, style, placement: plcmt }) => {
  const { is3xl, is2xl, isLg, isMd } = useBreakpoints();

  const plcmts = {
    topLeft: {
      top: `${is2xl ? '-64px' : isLg ? '-40px' : '-36px'}`,
      left: `${
        is3xl
          ? '226px'
          : is2xl
          ? '186px'
          : isLg
          ? '162px'
          : isMd
          ? '116px'
          : '52px'
      }`,
    },
    bottomRight: {
      bottomRight: {
        bottom: null,
        right: null,
      },
    },
  };

  return (
    <button
      type="button"
      className={`z-10 next-btn text-white p-2 disabled:opacity-50 disabled:cursor-default ml-4 md:ml-4 2xl:ml-8 3xl:ml-9 ${className}`}
      onClick={onClick}
      style={{
        ...style,
        display: 'block',
        position: 'absolute',
        top: `${plcmts[plcmt].top ? plcmts[plcmt].top : 'unset'}`,
        right: `${plcmts[plcmt].right ? plcmts[plcmt].right : 'unset'}`,
        bottom: `${plcmts[plcmt].bottom ? plcmts[plcmt].bottom : 'unset'}`,
        left: `${plcmts[plcmt].left ? plcmts[plcmt].left : 'unset'}`,
      }}
    >
      <ArrowRight
        // isShadowOn={buttonShadow}
        width={is2xl ? '24' : '12'}
        height={is2xl ? '40' : '20'}
      />
    </button>
  );
};

export default NextArrow;
